import React, { useState, useRef, useEffect } from "react";
import Layout from "containers/Layout";
import "react-dropdown/style.css";
import { getListTicket, updateDataSearch } from "../../../actions/Ticket";
import { Headersubfull } from "../../GenericComponent/HeaderSubFull/headersubfull";
import { SearchBarDesktop } from "./SearchBarDesktop";
import { SearchBarMobile } from "./SearchBarMobile";
import { useSelector, useDispatch } from "react-redux";
import { TableDanhSach } from "./TableDanhSach";
import { AddTaiKhoanBtn } from "./AddTaiKhoanBtn";
import dsBankApi from "service/TichHopBank/dsBankApi";
import LayoutV2 from "containers/LayoutV2";

export const DanhSachBank = () => {
  const dispatch = useDispatch();
  const [dataBank, setDataBank] = useState({});
  const dataSearch = useSelector((state) => state.dataSearchTaiKhoanBank);
  useEffect(() => {
    document.title =
      "Danh sách tài khoản Bank | Phần mềm quản lý cầm đồ Morman";
    onSearch();
  }, []);
  const onSearch = () => {
    dsBankApi
      .list({
        sSearch: dataSearch.sSearch,
        sMaNganHang: dataSearch.sMaNganHang,
        iPageSize: dataSearch.iPageSize,
        iPageIndex: dataSearch.iPageIndex,
        isKhoa: dataSearch.isKhoa,
        isDangKyNhanPushBDSD: dataSearch.isDangKyNhanPushBDSD,
      })
      .then((response) => {
        if (response.status == "200") {
          setDataBank(response.data);
        }
      });
  };

  return (
    <LayoutV2>
      <div id="form-repeater">
        <div className="sticky-moman-bh">
          <div className="col-12">
            <div className="camdo-home">
              <div className="breadcrumb-new hidden-mobile-main show-table-main">
                <div className="row">
                  <div className="col-sm-12 col-md-12 title-cd">
                    <div className="media-home align-center-home">
                      <div class="row header">
                        <img
                          className="icon-bred-home"
                          src="/app-assets/images/logo-tragop-v2.png"
                          alt=""
                        />
                        <h1 className="text-info-home">Bank</h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card border-light mb-1 hidden-mobile-main show-table-main card-v2">
              <div className="card-body card-body-v2">
                <SearchBarDesktop onSearch={onSearch} />
              </div>
            </div>
              <AddTaiKhoanBtn data={""} onSearch={onSearch} />
            <SearchBarMobile onSearch={onSearch} />
          </div>
        </div>
        <TableDanhSach dataDanhSach={dataBank} onSearch={onSearch} />
      </div>
    </LayoutV2>
  );
};
